(function() {
    'use strict';

    angular
        .module('quantixApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth','GenericService','vcRecaptchaService','$http','$state','$scope','$uibModal','$rootScope'];

    function RegisterController ($translate, $timeout, Auth, GenericService,vcRecaptchaService,$http,$state,$scope,$uibModal,$rootScope) {
        var vm = this;
        vm.publicKey = "6LfItR0UAAAAAI7yY9TTAp2mC40kVepEHrK77fpF";

        vm.dontmatch= null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;
        vm.cities = null;
        vm.departments = null;
        vm.otherDepartment=null;
        vm.designations = null;
        vm.otherDesignation=null;
        vm.notvalidmail =null
        vm.valid=false;
        vm.failure=false;
        vm.failureres=null;
        vm.registersuccess=registersuccess;
        $scope.emailerror=false;
        $scope.emailformaterror=true;
        $scope.logiderr=false;
       $scope.licerror=false;
        vm.oopsmes=false;
        $scope.passerror=true;
        vm.setRecaptchaId=setRecaptchaId;
        vm.recaptchaId=null;
        vm.captcha=true;
        vm.reset=reset;
        vm.termsOfUse=false;
        
           function setRecaptchaId(widgetId) {
            vm.recaptchaId = widgetId;
            if(vm.recaptchaId>=0){
            	vm.captcha=false;
            }else{
            	vm.captcha=true;
            }
        };
        
        
       var randmnum=0;

        function register () {

        	var response = vcRecaptchaService.getResponse(vm.recaptchaId);
        	 if(response === ""){
        		 vm.captcha=false;
             }else{
            	 vm.captcha=true;
             }
        	 
        	 if (vm.password !== vm.confirm) {
                $scope.passerror=false;
            }else{
            	   randmnum=Math.random();
            	   vm.registerAccount.passCheck=randmnum;
            	 vm.registerAccount.password=Auth.encryptPassword(vm.password+"_"+randmnum);
        		 vm.confirmPassword=Auth.encryptPassword(vm.confirm+"_"+randmnum);
            	  $scope.passerror=true;
            }
        	 if(vm.registerAccount.email.toUpperCase().indexOf('@CRISIL.COM') != -1){
            	 $scope.emailformaterror=false;
            } else{
            	 $scope.emailformaterror=true;
            } 
        	 

        	    vm.registerAccount.langKey = $translate.use();
                var registerdetails=vm.registerAccount;
                var url='api/registercheck';
                $http.post(url,registerdetails).then(function(response){
                	 var data=response.data;
                     $scope.emailerror=false;
                     $scope.logiderr=false;
                    $scope.licerror=false;
                     vm.oopsmes=false;
                     vm.failure=false;
                     vm.valid=false;
                     vm.check=false;
                 	for(var i=0;i<data.length;i++){
                 		if(data[i]==='Success'){
                 			vm.check=true;
                           vm.registerAccount.clientId=data[i+1];
                           break;
                     	  }
                 	  if(data[i]==='E-mail address already in use'){
                 		  $scope.emailerror=true;
                 	  }
                 	  if(data[i]==='Login already in use'){
                 		  $scope.logiderr=true;
                 	  }
                 	  if(data[i]==='License key is not valid'){
                 		 $scope.licerror=true;
                 	   }
                 	  if(data[i]==='Please fill all the required fields'){
                 		 vm.failure=true;
                   	 }
                 	}
                 	if(vm.captcha && $scope.passerror && $scope.emailformaterror){
                       	if(vm.check){
                    	var registereddata=vm.registerAccount;
                      	$state.go('smsotpverification',{registereddata:registereddata});
                       	}
                       }
                })["catch"](function(response){
                	vm.valid=false;
                	vm.check=false;
                	vm.oopsmes=true;
                })
            
        }
        function registersuccess(){}
function reset(){
	$state.reload();
}

        function getRequiredData(){
        	        	GenericService.getSelectBoxData().then(
			 function(data) {
				var cities=[];
				var departments=[];
				var designations=[];
				angular.forEach(data[0],function(row){
					cities.push({
						'cityid':row[0],
						'cityname':row[1]
					});
				});
				vm.cities = cities;
				angular.forEach(data[1],function(row){
					departments.push({
						'departmentid':row[0],
						'departmentname':row[1]
					});
				});
				vm.departments = departments;
				angular.forEach(data[2],function(row){
					designations.push({
						'designationid':row[0],
						'designationname':row[1]
					});
				});
				vm.designations = designations;
				
        });
        	
        }
        //Addedd by Nikhil Nale for id #48675
        $scope.openTermsOfUsePopUp=function(){
        	
        	 $uibModal.open({
        		 templateUrl: 'app/account/footer/termsofuse.html',
        		 controller :'ModelHandlerController',
        		 controllerAs: 'vm',
        		 size: 'lg',
        		 });
        }
        //Ends by Nikhil
        getRequiredData();
        
 
        /*start captch*/
        
        /*end captch*/
        
    }
})();
